<div class="accordion-form-wrapper w-full flex flex-col items-center" [id]="accordionData?.uuid">
  <div class="title-input-wrapper w-[95%]">
    <app-text-input (checkForErrors)="checkForErrors($event)" [error]="errorMessages['title']" [maxLength]="100000"
      [parentFormGroup]="accordionForm" class="resource-input" controlName="title" placeholder="Enter Title"
      type="small"></app-text-input>
  </div>
  <div class="content-section-wrapper w-[95%]">
    <ckeditor (change)="onChange($event)" [data]="editorContent" [editor]="Editor" [config]="config"
      class="prose"></ckeditor>
    <div class="content-block-error-wrapper">
      {{errorMessages['content']}}
    </div>
  </div>
</div>